import { SectionPaper } from "@/components/Paper";
import { Select } from "@/components/Select";
import { SectionTitle } from "@/components/Title";
import { DmUsageGrid } from "@/features/accountSettings/components";
import {
  DmUsagesAPI,
  MonthlyBudgetStatusListAPI,
} from "@/features/accountSettings/api";
import { getUsageYearMonthText } from "@/features/accountSettings/utils";
import { Box, Divider, Typography } from "@mui/material";
import { useMemo, useState } from "react";

interface UsageMonth {
  id: number;
  billingDate: Date;
}

/**
 * ログインユーザーのDM費用（R.E.DATA Plus 外で発生したDM関連費用）を月別に表示する。
 * 月の選択肢は消費クレジットと同じく月次予算状況から作る。
 */
export const DmUsage: React.FC = () => {
  const [usageMonth, setUsageMonth] = useState<UsageMonth | undefined>(
    undefined
  );

  const monthlyBudgetStatusListResponse = MonthlyBudgetStatusListAPI();

  const usageMonths: UsageMonth[] = useMemo(
    () =>
      monthlyBudgetStatusListResponse.map<UsageMonth>((data) => {
        return {
          id: data.id ?? 0,
          billingDate: data.billingDate
            ? new Date(data.billingDate)
            : new Date(),
        };
      }),
    [monthlyBudgetStatusListResponse]
  );

  const dmUsages = DmUsagesAPI(
    usageMonth?.billingDate.getFullYear(),
    usageMonth !== undefined ? usageMonth.billingDate.getMonth() + 1 : undefined
  );

  const totalAmount = (dmUsages ?? []).reduce(
    (total, dmUsage) => total + dmUsage.amount,
    0
  );

  const handleChange = (value: string): void => {
    setUsageMonth(usageMonths.find((e) => e.id === Number(value)));
  };

  return (
    <SectionPaper>
      <Box sx={{ display: "flex" }}>
        <SectionTitle>DM費用</SectionTitle>
        <Box sx={{ mx: "auto" }}></Box>
        <Box sx={{ display: "flex", alignItems: "center", mx: 1 }}>
          <Select
            label="月"
            isClearable={false}
            options={usageMonths.map((e) => {
              return {
                label: getUsageYearMonthText(e.billingDate),
                value: String(e.id),
              };
            })}
            onChange={handleChange}
          ></Select>
        </Box>
      </Box>
      <Divider />
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Box sx={{ mx: "auto" }}></Box>
        <SectionTitle>
          DM費用合計：{totalAmount.toLocaleString()}円
        </SectionTitle>
      </Box>
      {dmUsages !== undefined &&
        (dmUsages.length > 0 ? (
          <DmUsageGrid dmUsages={dmUsages}></DmUsageGrid>
        ) : (
          <Typography sx={{ m: 2 }}>該当する利用はありません</Typography>
        ))}
    </SectionPaper>
  );
};
